<template>
  <div>
    <el-dialog
      title="客户数量"
      :visible.sync="dialogVisible"
      width="1080px"
      :before-close="handleClose"
    >
      <div class="dl-page">
        <div class="search-layout">
          <div class="item-wrap">
            <el-input
              size="small"
              placeholder="客户名称"
              v-model="formIn.shopName"
            />
          </div>
          <div class="item-wrap">
            <SelectArea
              ref="refSelectArea"
              size="small"
              placeholder="业务区域"
              clearable
              @change="handleChangeForArea"
            />
          </div>
          <div class="item-wrap">
            <el-select
              size="small"
              placeholder="资质状态"
              clearable
              v-model="formIn.certifyStatus"
            >
              <el-option
                v-for="item in certifyStatusList"
                :key="item.typeCode"
                :label="item.typeName"
                :value="item.typeCode"
              />
            </el-select>
          </div>
          <div class="item-wrap op">
            <el-button size="small" @click="resetForm">重置</el-button>
            <el-button type="primary" size="small" @click="handleSearch">
              搜索
            </el-button>
          </div>
        </div>
        <div class="other-op-layout">
          <el-button
            type="primary"
            size="small"
            @click="handleClientTrans"
            v-if="!selection"
          >
            客户转移
          </el-button>

          <el-checkbox v-if="selection" v-model="transferAll"
            >选择全部</el-checkbox
          >

          <el-button
            type="primary"
            size="small"
            @click="handleSelectFinish"
            v-if="selection"
          >
            选择完成
          </el-button>
          <el-button size="small" @click="handleCancelTrance" v-if="selection">
            取消转移
          </el-button>
        </div>
        <div class="table-wrap">
          <MyTable
            :table-data="tableData"
            :index="index"
            :selection="selection"
            :page="page"
            :operation="false"
            :table-option.sync="tableOption"
            @page-change="getList"
            @handleSelectionChange="handleSelectionChange"
          >
            <!-- 资质状态 -->
            <template slot="qualificationStatus" slot-scope="scope">
              <div>
                {{ showStatus(scope.row) }}
              </div>
            </template>
          </MyTable>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="left"></div>
        <div class="right">
          <el-button @click="handleClose" size="small">取 消</el-button>
        </div>
      </span>
    </el-dialog>

    <SelectSalesman ref="refSelectSalesman" />
  </div>
</template>
<script>
import MyTable from "@/components/myTable";
import SelectArea from "@/components/SelectArea/index.vue";
import SelectSalesman from "./SelectSalesman.vue";
import {
  getSalesUserStatisticsManageBySalesIdPage,
  getSalesClientListPage,
} from "@/api/externalSalesRule/index.js";
import _ from "lodash";

export default {
  components: { MyTable, SelectSalesman, SelectArea },

  data() {
    return {
      rowData: null,

      certifyStatusList: [
        {
          typeName: "正常",
          typeCode: 1,
        },
        {
          typeName: "过期",
          typeCode: 2,
        },
        {
          typeName: "临期",
          typeCode: 3,
        },
      ],

      tabsIndex: "-1",
      operation: true,
      selection: false,
      index: false,
      tableData: [],
      tableOption: [
        { label: "客户ID", prop: "shopId", minWidth: 100 },
        { label: "客户名称", prop: "shopName", minWidth: 120 },
        { label: "客户类型", prop: "shopType", minWidth: 120 },
        {
          label: "省",
          prop: "provinceName",
          minWidth: 80,
        },
        {
          label: "市",
          prop: "cityName",
          minWidth: 80,
        },
        {
          label: "区",
          prop: "areaName",
          minWidth: 80,
        },
        { label: "详情地址", prop: "detailedAddress", minWidth: 160 },
        {
          label: "资质状态",
          prop: "qualificationStatus",
          slot: true,
          minWidth: 80,
        },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 50, 100],
      },

      dialogVisible: false,
      formIn: {
        shopName: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        certifyStatus: "",
      },

      selectedList: null,
      transferAll: false,
    };
  },
  created() {
    this.initEvent();
  },
  destroyed() {
    //
  },
  methods: {
    initEvent() {
      this.$bus.$on("refresh", () => {
        this.handleSearch();
      });
    },
    showStatus(row) {
      let certifyStatus = "";
      const findedItem = this.certifyStatusList.find(
        (item) => item.typeCode == row.qualificationStatus
      );
      if (findedItem) {
        certifyStatus = findedItem.typeName;
      } else {
        certifyStatus = "无资质";
      }
      return certifyStatus;
    },
    handleSelectionChange(val) {
      this.selectedList = val;
    },
    handleSelectFinish() {
      if (
        !this.transferAll &&
        (!this.selectedList || this.selectedList.length == 0)
      ) {
        this.$message.warning("请选择待转移的客户");
        return;
      }
      this.$refs.refSelectSalesman.open(
        this.selectedList,
        this.rowData,
        this.transferAll
      );
    },
    handleChangeForArea(val) {
      this.formIn.provinceName = "";
      this.formIn.cityName = "";
      this.formIn.areaName = "";

      if (val instanceof Array && val.length == 1) {
        const labels = val[0].pathLabels;
        if (labels instanceof Array) {
          if (labels.length > 0) {
            this.formIn.provinceName = labels[0];
          }
          if (labels.length > 1) {
            this.formIn.cityName = labels[1];
          }
          if (labels.length > 2) {
            this.formIn.areaName = labels[2];
          }
        }
      }
    },
    handleClientTrans() {
      this.selection = true;
    },
    handleCancelTrance() {
      this.selection = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    init() {
      //
    },
    submitUpload() {
      // this.dialogVisible = false;
    },
    resetForm() {
      for (let key in this.formIn) {
        this.formIn[key] = "";
      }
      this.$refs.refSelectArea.clear();
    },
    handleSearch() {
      this.page.current = 1;
      this.getList();
    },
    getList() {
      const { current, size } = this.page;
      let params = {
        current,
        size,
        salesUserId: this.rowData.id,
      };
      _.merge(params, this.formIn);

      getSalesClientListPage(params).then((data) => {
        if (data) {
          const { records, total } = data;
          this.page.total = total;
          this.tableData = records;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
    clear() {
      for (let key in this.formIn) {
        this.formIn[key] = "";
      }
      this.rowData = null;
      this.selection = false;
      this.tableData = [];
    },
    open(row) {
      this.clear();
      this.dialogVisible = true;

      this.rowData = _.cloneDeep(row);

      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
@import "../style/index.scss";
.form-centent {
  .row {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 8px;
    }

    .tip {
      width: 4em;
    }

    .value {
      width: 240px;
      margin-left: 8px;

      & > * {
        width: 100%;
      }
    }
  }
}
</style>
